// extracted by mini-css-extract-plugin
export default {"modalOverlay":"zJ-z","modalContent":"AJ-z","header":"BJ-z","close":"CJ-z"};